module.exports = {"410122001":"青年路街道","410122002":"东风路街道","410122003":"广惠街街道","410122101":"韩寺镇","410122102":"官渡镇","410122103":"狼城岗镇","410122104":"万滩镇","410122105":"白沙镇","410122106":"郑庵镇","410122109":"黄店镇","410122110":"大孟镇","410122112":"刘集镇","410122114":"雁鸣湖镇","410122115":"姚家镇","410122208":"刁家乡","410122570":"杨桥","410122571":"豫兴"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410122.json
// module id = 1395
// module chunks = 0